import axios from 'axios'
import { APISERVERURL } from '../APIServerURL';
export default axios.create(
    {
        baseURL:APISERVERURL+"/fourthconvocationbulk"
    }
);